<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab" (window:resize)="onResize($event)">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>
			<div class="c-portlet__header">
				<div class="o-stack__cell">
					<h5 class="card-title">Conversions Breakdown</h5>
					<span class="datatable-icon">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCsv($event)"
							target="_blank"
							*ngIf="devicedatatableconfig && devicedatatableconfig.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
			</div>
			<div [hidden]="!hasData || !selectedGraphData" #chartcontainer class="donut-div">
				<h4 *ngIf="selectedGraphData && !isPreroll" class="device-series-titlename">
					{{ selectedGraphData.seriesName | titlecase }} by Action Name
				</h4>
                <app-generic-chart
					[colorPalette]="colorPalette"
					[configuration]="widgetsConfiguration"
					[data]="deviceData"
				></app-generic-chart>
				<div *ngIf="!selectedGraphData || !selectedGraphData.seriesHasData" class="device-metric-no-data">
					No Data Available
				</div>
			</div>
		</div>
		<div class="card card1 mLeft devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="devices-data-container height-100p" *ngIf="hasData">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5>Conversions</h5>
					</div>
				</div>
                <div class="conversion-details">
                    <div class="conversion-row" *ngFor="let metric of metricObject">
                        <div class="each-conversion-name"
                        >
						<span
						appTooltip
                        title="metric.tooltip"
                        [title]="metric.tooltip"
                        [options]="tooltipOptions"
						>
						{{metric.name}}
						</span>
						</div>
                        <div class="each-conversion-value">{{metric.value}}</div>
                    </div>
                </div>
				<div class="device-breakdown-data">
					<div>
						<div class="devices-header-row">
							<div class="width-65p device-data">Conversion Action Name</div>
							<div class="width-33p device-data">Conversions</div>
						</div>
						<div class="devices-body">
							<div *ngFor="let device of deviceData; let index = index">
								<div
									class="width-65p device-data font-600p"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2,
                                        'quaternary-color': index === 3,
                                        'quinary-color': index === 4
									}"
								>
								<span
									appTooltip
									title="device.tooltip"
									[title]="device.tooltip"
									[options]="tooltipOptions"
									*ngIf="device.tooltip"
								>
									{{ device.conversion_action }}
								</span>
								<span *ngIf="!device.tooltip">
									{{ device.conversion_action }}
								</span>
								</div>
								<div
									class="width-33p device-data"
									[ngClass]="{
										'primary-color': index === 0,
										'secondary-color': index === 1,
										'tertiary-color': index === 2,
                                        'quaternary-color': index === 3,
                                        'quinary-color': index === 4
									}"
								>
									<div *ngIf="device.conversions">{{ device.conversions | formatNumber }}</div>
									<div *ngIf="!device.conversions">--</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
